import React, { PureComponent } from 'react'
import { connect } from 'react-redux'
import MerchandiseLineItem from './MerchandiseLineItem'
import { Icon } from 'semantic-ui-react'
import { createMerchandiseLineItem } from '../../api/createItem'
import _ from 'lodash'
class MerchandiseLineItems extends PureComponent {
  constructor(props) {
    super(props)
    this.state = {
      isAdding: false
    }
  }
  updateAddStatus = (merchandiseId) => {
    this.setState({
      isAdding: {
        [merchandiseId]: false
      }
    })
  }
  
  render() {
    const { merchandiseLineItems,shipmentETA, expandAll, isDisabled , invoiceItemIndex , invoiceIndex , showFrightData ,invoiceId , expandAllLines, pscData, currentJobData,
      currencyConversionRate,currencyExchangeInfo,updateType, isBrokerKnAdmin} = this.props
  
    let uniquemerch = _.uniq(merchandiseLineItems);
    return (
      <React.Fragment>
        {
          uniquemerch.map((item, index) => {
            let articleSubComponent = item.articleSubComponent;
            if(item.articleHeader === 'X' || !item.articleHeader){
              return (
                <div className={`articleHeader${item.articleHeader?item.articleHeader:''}`} style={{width :"100%"}} key={index}>
                  <MerchandiseLineItem
                    key={'merchandiseLinItem' + item.merchandiseId}
                    modeOfTransport={this.props.modeOfTransport}
                    isPscMode={this.props.isPscMode}
                    lineItemIndex={index}
                    indexVal={index}
                    articleHeader={item.articleHeader}
                    articleSetId={item.articleSetId}
                    seqNo={item.seqNo}
                    articleSubComponent={articleSubComponent || []}
                    validateFormzz={this.props.validateFormzz}
                    totalLineItems={merchandiseLineItems.length}
                    expandAll={expandAll}
                    isDisabled={isDisabled}
                    invoiceItemIndex={invoiceItemIndex}
                    invoiceIndex={invoiceIndex}
                    pscState={this.props.pscState}
                    showFrightData={showFrightData}
                    expandAllLines={expandAllLines}
                    refreshESFrom={this.props.refreshESFrom}
                    shipmentETA={shipmentETA}
                    currentJobData={currentJobData}
                    currencyConversionRate={currencyConversionRate}
                    currencyExchangeInfo={currencyExchangeInfo}
                    updateType={updateType}
                    isBrokerKnAdmin={isBrokerKnAdmin}
                    kxUserBasicInfo={this.props.kxUserBasicInfo}
                  />
                  {
                    articleSubComponent && articleSubComponent.length > 0 && <div className={`articleSetSubComponent`}>{(uniquemerch.map((vItem, vIndex)=>{
                      if(articleSubComponent.includes(vItem.merchandiseId) && vItem.articleSetId === item.merchandiseId && vItem.articleHeader === 'V'){
                        return (
                          <div className={`articleHeader${vItem.articleHeader?vItem.articleHeader:''}`} style={{width :"100%"}} key={vIndex}>
                            <MerchandiseLineItem
                              key={'merchandiseLinItem' + vItem.merchandiseId}
                              modeOfTransport={this.props.modeOfTransport}
                              lineItemIndex={vIndex}
                              indexVal={articleSubComponent.indexOf(vItem.merchandiseId)}
                              invoiceItemIndex={invoiceItemIndex}
                              invoiceIndex={invoiceIndex}
                              articleHeader={vItem.articleHeader}
                              articleSetId={vItem.articleSetId}
                              articleSubComponent={articleSubComponent}
                              seqNo={vItem.seqNo}
                              validateFormzz={this.props.validateFormzz}
                              totalLineItems={merchandiseLineItems.length}
                              expandAll={expandAll}
                              isDisabled={isDisabled}
                              pscState={this.props.pscState}
                              refreshESFrom={this.props.refreshESFrom}
                              parentHts = {item.merchandiseDuties[0].htsus}
                              showFrightData={showFrightData}
                              expandAllLines={expandAllLines}
                              shipmentETA={shipmentETA}
                              currentJobData={currentJobData}
                              currencyConversionRate={currencyConversionRate}
                              currencyExchangeInfo={currencyExchangeInfo}
                              updateType={updateType}
                              isBrokerKnAdmin={isBrokerKnAdmin}
                              kxUserBasicInfo={this.props.kxUserBasicInfo}
                              
                            />
                            </div>
                          )
                      }
                    }))
                  }</div>
                  }
                  {
                    item.articleHeader === 'X' && <a
                    disabled={isDisabled('addHTS')}
                  ><span 
                    className='addArticleSet' 
                    onClick={()=>{
                      this.setState({
                        isAdding: {
                          [item.merchandiseId]: true
                        }
                      })
                      createMerchandiseLineItem( invoiceId, invoiceItemIndex,this.updateAddStatus, 'ArticleSetSubComponent', item.merchandiseId, pscData.pscShipmentId)
                    }}>
                      <Icon name='add circle' 
                      disabled={isDisabled('addHTS')}/> {this.state.isAdding[item.merchandiseId] ? `Adding component...`: `Add article set component` }
                    </span></a>
                  }
                </div> 
            )
          }
      }
      )}
      </React.Fragment>
    )
  }
}

const mapStateToProps = (state, props) => ({
  invoiceItemIndex: props.invoiceItemIndex,
  invoiceId : state.DescriptionOfMerchandise.entrySummaryInvoices[props.invoiceItemIndex]?.invoiceId, 
  merchandiseLineItems: state.DescriptionOfMerchandise.entrySummaryInvoices[props.invoiceItemIndex].merchandiseLineItems,
  fieldValidations: state.FieldValidation.fields || [],
  warnings: state.FieldValidation.warnings || [],
  pscData: state.PSC
})

const mapDispatchToProps = {}

export default React.memo(connect(
  mapStateToProps,
  mapDispatchToProps
)(MerchandiseLineItems))